import { DeepPartial, ISettingsVisibility } from 'services/player';

// Everything shown until the server says otherwise (and for older servers that
// send no visibility). The server's SETTINGS_ROW_VISIBILITY is merged over this.
export const SETTINGS_VISIBILITY_DEFAULTS: ISettingsVisibility = {
  settings: {
    accountInfo: { phone: true, email: true, changePassword: true },
    notifications: { allOnOff: true, editNotifications: true },
    appDefaults: {
      openingCasino: true,
      openingPage: true,
      exploreInsight: true,
      exploreTimeframe: true,
      compareInsights: true,
      compareTimeframe: true,
      drawerState: true,
    },
    restoreDefaults: true,
  },
  appDefaultOptions: { resetToDefault: true },
  notificationSettings: {
    channels: { inApp: true, push: true, email: true, sms: true },
    topics: { events: true, leaderboards: true },
    groups: { newsAndUpdates: true, allSlots: true, favoriteSlots: true, playlistSlots: true },
    resetToDefault: true,
  },
  newsAndUpdates: {
    weeklyTopSlots: true,
    weeklyTopPlayers: true,
    appUpdates: true,
    newSlots: true,
    resetToDefault: true,
  },
  slotNotifications: { all: true, jackpotHit: true, trending: true, resetToDefault: true },
};

type Flags = { [key: string]: boolean | Flags };

// Only booleans are taken from the server, so a missing or malformed entry keeps its default.
const mergeFlags = (base: Flags, patch: unknown): Flags => {
  if (!patch || typeof patch !== 'object') return base;
  const source = patch as Record<string, unknown>;
  return Object.keys(base).reduce<Flags>((merged, key) => {
    const value = base[key];
    merged[key] =
      typeof value === 'boolean'
        ? typeof source[key] === 'boolean'
          ? (source[key] as boolean)
          : value
        : mergeFlags(value, source[key]);
    return merged;
  }, {});
};

export const resolveSettingsVisibility = (
  visibility?: DeepPartial<ISettingsVisibility>
): ISettingsVisibility =>
  mergeFlags(
    SETTINGS_VISIBILITY_DEFAULTS as unknown as Flags,
    visibility
  ) as unknown as ISettingsVisibility;

// True when at least one row in a section is shown.
export const anyVisible = (section: Record<string, boolean>) =>
  Object.values(section).some(Boolean);
